import ReactGA from 'react-ga4';

// Google Analytics Measurement ID
const getGAMeasurementId = () => process.env.REACT_APP_DINO_GA_MEASUREMENT_ID;

// Google Analyticsが有効かどうかをチェック
export const isGAEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const gaMeasurementId = getGAMeasurementId();
  return !!(gaMeasurementId && ReactGA.isInitialized);
};

// Google Analyticsの初期化
export const initializeGA = () => {
  const gaMeasurementId = getGAMeasurementId();
  if (gaMeasurementId && !ReactGA.isInitialized) {
    ReactGA.initialize(gaMeasurementId);
  }
};

// ページビューを送信
export const trackPageView = (path: string, title?: string): void => {
  if (!isGAEnabled()) {
    if (process.env.NODE_ENV !== 'test' && process.env.NODE_ENV !== 'development') {
      console.warn('Google Analytics is not enabled or configured');
    }
    return;
  }
  try {
    ReactGA.send({ hitType: 'pageview', page: path, title: title || document.title });
  } catch (error: any) {
    console.error('Error tracking page view:', error);
  }
};

// カスタムイベントを送信
export const trackEvent = (eventName: string, parameters?: Record<string, any>): void => {
  if (!isGAEnabled()) {
    if (process.env.NODE_ENV !== 'test' && process.env.NODE_ENV !== 'development') {
      console.warn('Google Analytics is not enabled or configured');
    }
    return;
  }
  try {
    ReactGA.event(eventName, parameters);
    // eslint-disable-next-line no-console
    console.log(`GA: Event tracked - ${eventName}`, parameters);
  } catch (error: any) {
    console.error('Error tracking event:', error);
  }
};

// よく使用されるイベントのヘルパー関数
export const trackSearch = (searchTerm: string): void => {
  trackEvent('search', {
    search_term: searchTerm,
  });
};

export const trackClick = (elementName: string, location?: string): void => {
  trackEvent('click', {
    element_name: elementName,
    location: location,
  });
};

export const trackShare = (contentType: string, itemId?: string): void => {
  trackEvent('share', {
    content_type: contentType,
    item_id: itemId,
  });
};

export const trackError = (errorMessage: string, location?: string): void => {
  trackEvent('exception', {
    description: errorMessage,
    fatal: false,
    location: location,
  });
};

// analyticsオブジェクトとしてexport
export const analytics = {
  initializeGA,
  isGAEnabled,
  trackPageView,
  trackEvent,
  trackSearch,
  trackClick,
  trackShare,
  trackError,
};
